 import React from 'react';
import { 
  Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, 
  ListItemText, Typography, Divider, Chip 
} from '@mui/material';
import { 
  Dashboard, Storefront, People, ContactSupport, 
  BarChart, AssignmentInd, EventNote, Settings, ChevronRight
} from '@mui/icons-material';

const drawerWidth = 280;

const menuGroups = [
  {
    subheader: "INTELLIGENCE",
    items: [
      { text: "Overview", icon: <Dashboard />, path: "/analytics/overview" },
      { text: "Store Performance", icon: <BarChart />, path: "/analytics/stores" },
    ]
  },
  {
    subheader: "NETWORK MANAGEMENT",
    items: [
      { text: "Stores", icon: <Storefront />, path: "/network/stores", count: "12" },
      { text: "Agents / Managers", icon: <AssignmentInd />, path: "/network/agents" },
      { text: "Internal Users", icon: <People />, path: "/network/users" },
    ]
  },
  {
    subheader: "SALES & CRM",
    items: [
      { text: "Inquiries", icon: <ContactSupport />, path: "/crm/inquiries", count: "5" },
      { text: "Scheduled Demos", icon: <EventNote />, path: "/crm/demos" },
    ]
  }
];

export default function Sidebar() {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { 
          width: drawerWidth, 
          boxSizing: 'border-box',
          borderRight: '1px solid #eee',
          bgcolor: '#fff' 
        },
      }}
    >
      {/* BRANDING LOGO AREA */}
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box 
          sx={{ 
            width: 35, height: 35, bgcolor: '#f6521a', 
            borderRadius: 1.5, display: 'flex', justifyContent: 'center', alignItems: 'center',
            color: 'white', fontWeight: 900
          }}
        >
          T
        </Box>
        <Box>
          <Typography variant="subtitle1" fontWeight={800} lineHeight={1}>
            TPOS <span style={{ color: '#f6521a' }}>Hub</span>
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Management Hub
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ mx: 2, mb: 1 }} />

      {/* NAVIGATION ITEMS */}
      <Box sx={{ overflow: 'auto', px: 2 }}>
        {menuGroups.map((group, index) => (
          <Box key={index} sx={{ mb: 3 }}>
            <Typography 
              variant="caption" 
              fontWeight={700} 
              sx={{ color: '#999', ml: 2, mb: 1, display: 'block', letterSpacing: 1.2 }}
            >
              {group.subheader}
            </Typography>
            
            <List disablePadding>
              {group.items.map((item) => (
                <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
                  <ListItemButton 
                    sx={{ 
                      borderRadius: 2,
                      '&:hover': { bgcolor: '#fff5f2', color: '#f6521a', '& .MuiListItemIcon-root': { color: '#f6521a' } }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40, color: '#666' }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.text} 
                      primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }} 
                    />
                    {item.count && (
                      <Chip 
                        label={item.count} 
                        size="small" 
                        sx={{ height: 20, fontSize: '10px', bgcolor: '#f6521a', color: 'white', fontWeight: 700 }} 
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </Box>

      {/* FOOTER / SETTINGS */}
      <Box sx={{ mt: 'auto', p: 2 }}>
        <ListItemButton sx={{ borderRadius: 2 }}>
          <ListItemIcon sx={{ minWidth: 40 }}><Settings /></ListItemIcon>
          <ListItemText primary="Settings" primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }} />
        </ListItemButton>
      </Box>
    </Drawer>
  );
}